import * as Doka from "../lib/doka/esm/doka.esm.min.js";
import Sortable from "sortablejs";
import { Headers } from "whatwg-fetch";
import TextGenerator from "../lib/textgenerator.js";

import {
  DOKA_EDITOR_CROP_ASPECT_RATIO_OPTIONS,
  DOKA_EDITOR_LABELS,
  FILEPOND_LABELS,
} from "../helper/filepond.js";

if ($("#rental-edit").length) {
  if (window.location.hash && window.location.hash.startsWith("#preview")) {
    setTimeout(function () {
      $(".btn.preview").trigger("click");
    }, 2000);
  }

  document.querySelectorAll('input[type="text"]').forEach(function (input) {
    input.addEventListener("keypress", function (event) {
      var node = event.target || null;
      if (event.keyCode == 13 && node.type == "text") {
        event.preventDefault();
      }
    });
  });

  if ($(".quality-counter").length) {
    $(".quality-counter").each(function (idx, item) {
      let $counter = $(item);
      let count = 0;
      let label = "";
      let trans_string = $counter.data("string");
      $($counter.data("field")).on("keyup", function () {
        count = $(this).val().length;
        label = global.Translator.transChoice(trans_string, count, {}, "js");
        $counter.text(" " + label);
        if (count < 0) {
          $counter.addClass("error");
        } else {
          $counter.removeClass("error");
        }
      });
      $($counter.data("field")).trigger("keyup");
    });
  }

  if ($(".char-help").length) {
    $(".char-help").each(function (idx, item) {
      var $helper = $(item);
      $($helper.data("field")).on("keyup", function () {
        var show = $helper.data("amount") - $(this).val().length > 0;
        if (show) {
          $helper.removeClass("invisible");
        } else {
          $helper.addClass("invisible");
        }
      });
      $($helper.data("field")).trigger("keyup");
    });
  }

  var $pictures = $("#pictures");
  if ($pictures.length) {
    let rest = $(".image-counter").data("limit") || 0;
    rest = rest < 0 ? 0 : rest;
    var pond = null;
    if ($(".upload-wrap").length) {
      FilePond.registerPlugin(
        FilePondPluginFileValidateType,
        FilePondPluginImageExifOrientation,
        FilePondPluginImagePreview,
        FilePondPluginImageCrop,
        FilePondPluginImageResize,
        FilePondPluginImageTransform,
        FilePondPluginImageEdit
      );

      var $rentalId = $("#rental-edit").data("id");

      pond = FilePond.create(document.getElementById("fileupload-input"), {
        allowMultiple: true,
        acceptedFileTypes: ["image/*", ".heic", ".HEIC"],
        fileValidateTypeDetectType: (source, type) => {
          return new Promise((resolve, reject) => {
            if (/\.heic$/i.test(source.name)) type = "image/heic";
            resolve(type);
          });
        },
        imageTransformOutputStripImageHead: false,
        allowFileTypeValidation: true,
        maxFileSize: "30MB",
        server: {
          url: window.location.protocol + "//" + window.location.host,
          process: {
            url: "/admin/picture/" + $rentalId,
            onerror: (response) => {
              return response;
            },
          },
          revert: function (uniqueFileId, load, error) {
            console.log(error);
            let deleteUrl = "/admin/picture/" + $rentalId + "/" + uniqueFileId;
            sendRequest(deleteUrl, "", "DELETE");
            load();
          },
        },
        // instantUpload: false,
        allowReorder: true,
        allowProcess: false,
        maxParallelUploads: 1,
        itemInsertLocation: (a, b) => {
          // If no file data yet, treat as equal
          if (!(a.file && b.file)) return 0;

          // Move to right location in list
          if (a.fileSize < b.fileSize) {
            return -1;
          } else if (b.fileSize > a.fileSize) {
            return 1;
          }

          return 0;
        },
        name: "fileupload",
        ...FILEPOND_LABELS,
        imageResizeTargetWidth: 2200,
        onerror: (error, file, status) => {
          console.log(error);
          if (error.body == "Max files") {
            let message = global.Translator.transChoice(
              "rental.upload.max_files_warning",
              rest,
              { "%count%": rest },
              "js"
            );
            alert(message);
          } else if (error.body === "error.picture.duplicate") {
            let message = global.Translator.trans(
              `rental.upload.${error.body}`,
              { name: file.file.name },
              "js"
            );
            alert(message);
          }
        },
        onwarning: (error, file, status) => {
          if (error.body == "Max files") {
            let message = global.Translator.transChoice(
              "rental.upload.max_files_warning",
              rest,
              { "%count%": rest },
              "js"
            );
            alert(message);
          }
          console.log(error);
        },

        // configure Doka
        imageEditEditor: Doka.create({
          ...DOKA_EDITOR_LABELS,
          utils: ["crop", "color"],
          cropAspectRatioOptions: DOKA_EDITOR_CROP_ASPECT_RATIO_OPTIONS,
        }),
      });
    }

    $pictures.on("click", ".list .thumbnail", function () {
      var idx = $(this).attr("data-idx");
      $(this)
        .parents(".list:eq(0)")
        .find(".thumbnail > .bgi")
        .removeClass("active");
      $(this).find("> .bgi").addClass("active");
      $pictures
        .find(".single")
        .find(".thumbnail")
        .removeClass("active")
        .addClass("hidden");
      $pictures
        .find(".single")
        .find(".thumbnail[data-idx=" + idx + "]")
        .addClass("active")
        .removeClass("hidden");

      //window.dispatchEvent(new Event('resize'));
      window.dispatchCBEvent(window, "resize");
    });

    $pictures.on("click", ".single .delete .btn", function (e) {
      e.preventDefault();
      e.stopPropagation();
      var idx = $(this).attr("data-idx");
      var grid_col = $pictures
        .find(".list .thumbnail[data-idx=" + idx + "]")
        .parent();
      grid_col.next().find(".thumbnail").length
        ? grid_col.next().find(".thumbnail").trigger("click")
        : grid_col.prev().find(".thumbnail").length
          ? grid_col.prev().find(".thumbnail").trigger("click")
          : "";
      grid_col.remove();
      $pictures.find(".single .thumbnail[data-idx=" + idx + "]").remove();
      sendRequest($(this).attr("href"), "", "DELETE");
      window.dispatchCBEvent($pictures.find(".list")[0], "change");
    });

    if ($pictures.find(".single .title").length) {
      $(".single .title label").on(
        "change",
        "input[type=checkbox]",
        function () {
          if ($(this).prop("checked") == true) {
            $(".single .title label input[type=checkbox]").prop(
              "checked",
              false
            );
            $(this).prop("checked", true);
            $(".list .thumbnail .title").removeClass("title");
            $(
              ".list .thumbnail[data-idx=" + $(this).data("idx") + "] > .bgi"
            ).addClass("title");
          } else if (
            $(".single .title label input[type=checkbox]:checked").length == 0
          ) {
            $(".list .thumbnail .title").removeClass("title");
          }
        }
      );
    }

    if ($(".image-counter").length) {
      $(".image-counter").each(function (idx, item) {
        var $counter = $(item);
        $pictures.find(".list").on("change", function () {
          rest =
            $counter.data("limit") -
            $pictures.find(".list").find(".thumbnail").length;
          rest = rest < 0 ? 0 : rest;
          $counter.text(
            global.Translator.transChoice(
              "rental.upload.counter",
              rest,
              { "%count%": rest },
              "js"
            )
          );

          if (rest == 0) {
            $pictures.find(".upload-wrap").addClass("hidden");
          } else {
            $pictures.find(".upload-wrap").removeClass("hidden");
          }
          if (typeof pond !== "undefined") {
            pond.setOptions({ maxFiles: rest });
          }
        });
        //$pictures.find('.list')[0].dispatchEvent(new Event('change'));
        window.dispatchCBEvent($pictures.find(".list")[0], "change");
      });
    }

    var pictureList = document.getElementById("sortable");
    var sortable = Sortable.create(pictureList);

    $pictures.find(".list").on("change", function () {
      $pictures.find(".list .thumbnail").each(function (index, item) {
        $pictures.find("#picture_sort_" + $(item).data("idx")).val(index);
        $pictures
          .find(".single .thumbnail[data-idx=" + $(item).data("idx") + "]")
          .trigger("change");
      });

      if (typeof pond !== "undefined") {
        pond.setOptions({ maxFiles: rest });
      }
    });

    $pictures.find(".single .thumbnail").on("change", function () {
      batchChanges($(this));
    });
    $pictures.find(".single .thumbnail input").on("keyup", function () {
      $(this).parents(".thumbnail").trigger("change");
    });

    let changes = [];
    let timeoutId = null;

    function batchChanges($this) {
      let pictureId = $this.data("idx");
      let patchUrl = $this.data("url");
      let $item = $pictures.find(
        ".single .thumbnail[data-idx=" + pictureId + "]"
      );
      let description = $item.find("#picture_description_" + pictureId).val();
      let pos = $item.find("#picture_sort_" + pictureId).val();
      let data = {
        sort: pos,
        description: description,
        id: pictureId,
        rental_id: $rentalId,
      };

      let existingChange = changes.findIndex(
        (change) => change.data.id === pictureId
      );

      if (existingChange !== -1) {
        changes[existingChange] = { url: patchUrl, data: data };
      } else {
        changes.push({ url: patchUrl, data: data });
      }

      if (timeoutId !== null) {
        clearTimeout(timeoutId);
      }

      timeoutId = setTimeout(function () {
        sendBatchRequest(changes);
        changes = [];
      }, 1000);
    }

    function sendBatchRequest(changes) {
      let batchUrl = "/admin/picture/batch/" + $rentalId;
      let data = changes.map((change) => change.data);
      sendRequest(batchUrl, data, "POST");
    }

    function sendRequest(url, data, method) {
      return window
        .fetch(url, {
          // credentials: 'same-origin', // 'include', default: 'omit'
          method: method, // 'GET', 'PUT', 'DELETE', etc.
          body: JSON.stringify(data), // Coordinate the body type with 'Content-Type'
          headers: new Headers({
            "Content-Type": "application/json",
          }),
        })
        .then((response) => response.json());
    }

    let thumbnailTimeouts = [];

    function saveChanges($this) {
      let pictureId = $this.data("idx");
      clearTimeout(thumbnailTimeouts[pictureId]);
      thumbnailTimeouts[pictureId] = setTimeout(function () {
        let patchUrl = $this.data("url");
        let $item = $pictures.find(
          ".single .thumbnail[data-idx=" + pictureId + "]"
        );
        let description = $item.find("#picture_description_" + pictureId).val();
        let pos = $item.find("#picture_sort_" + pictureId).val();
        let data = { sort: pos, description: description };
        sendRequest(patchUrl, data, "PATCH");
      }, 1000);
    }
  }

  if ($("#useAccountAddress").length) {
    $("#useAccountAddress").on("change", function () {
      if ($(this).prop("checked") == true) {
        $("[data-use_account_address]").each(function (idx, item) {
          $(item).val($(item).attr("data-use_account_address"));
          if ($(item)[0].tagName == "SELECT") {
            $(item)
              .find(
                'option[value="' +
                  $(item).attr("data-use_account_address") +
                  '"]'
              )
              .attr("selected", "selected");
          }
          $(item).next("label").addClass("mdc-floating-label--float-above");
        });
      } else {
        $("[data-use_account_address]").each(function (idx, item) {
          $(item).val("");
          if ($(item)[0].tagName == "SELECT") {
            $(item).find("option:first").attr("selected", "selected");
          }
          $(item).next("label").removeClass("mdc-floating-label--float-above");
        });
      }
      $("#rental_city[data-use_account_address]").eq(0).trigger("keyup");
    });
    $("[data-use_account_address]").each(function (idx, item) {
      $(item).val($(item).attr("data-use_account_address"));
      if ($(item)[0].tagName == "SELECT") {
        $(item)
          .find(
            'option[value="' + $(item).attr("data-use_account_address") + '"]'
          )
          .attr("selected", "selected");
      }
      $(item).next("label").addClass("mdc-floating-label--float-above");
    });
    $("#rental_city[data-use_account_address]").eq(0).trigger("keyup");
  }
  if ($("#useAccountContact").length) {
    let phoneWidget = $(".phone-number").eq(0) || null;
    if ($("p[data-phone_account_contact]").length && phoneWidget != null) {
      var accountPhoneNumber = JSON.parse(
        $("p[data-phone_account_contact]").attr("data-phone_account_contact")
      );
      phoneWidget
        .find("select")
        .eq(0)
        .attr("data-use_account_contact", accountPhoneNumber.country);
      phoneWidget
        .find("select")
        .eq(1)
        .attr("data-use_account_contact", accountPhoneNumber.type);
      phoneWidget
        .find("input")
        .eq(0)
        .attr("data-use_account_contact", accountPhoneNumber.content)
        .removeClass("clean");
    }
    $("#useAccountContact").on("change", function () {
      if ($(this).prop("checked") == true) {
        $("[data-use_account_contact]").each(function (idx, item) {
          $(item).val($(item).attr("data-use_account_contact"));
          $(item).next("label").addClass("mdc-floating-label--float-above");
        });
      } else {
        $("input[data-use_account_contact]").each(function (idx, item) {
          $(item).val("");
          $(item).next("label").removeClass("mdc-floating-label--float-above");
        });
      }
    });
    $("input[data-use_account_contact]").each(function (idx, item) {
      $(item).val($(item).attr("data-use_account_contact"));
      $(item).next("label").addClass("mdc-floating-label--float-above");
    });
  }

  if ($(".feature-lock").length) {
    $(".feature-lock").on("click", function () {
      $(this).addClass("feature-lock-open");
      $(this)
        .parents(".sctn")
        .eq(0)
        .find(".feature-from")
        .removeClass("hidden");
      if ($(this).parents("#prices").length) {
        $(this)
          .parents("#prices")
          .find(".feature-lock")
          .addClass("feature-lock-open");
      }
    });
  }

  $("#rental-edit form .submit").on("click", function () {
    $(".languageBox .nav li:first-child").trigger("click");
    $(this).submit();
  });

  window.validateLanguageBox = function ($form, e) {
    let errorLabel = false;
    let validationSuffix = "";
    $form.find("select, input, textarea").each(function (idx, item) {
      if (typeof $(item).attr("required") !== "undefined") {
        if (
          $(item)[0].tagName == "SELECT" &&
          $(item)[0].options[$(item)[0].selectedIndex].value == ""
        ) {
          errorLabel = $(item).parents(".mdc-text-field").find("label").text();
          return;
        }

        if (
          $(item)[0].tagName == "INPUT" &&
          $(item)[0].value == "" &&
          $(item).parents(".mdc-text-field").find("label").length > 0
        ) {
          errorLabel = $(item).parents(".mdc-text-field").find("label").text();
          return;
        }

        if ($(item)[0].tagName == "TEXTAREA" && $(item)[0].text.trim() == "") {
          errorLabel = $(item).parents(".mdc-text-field").find("label").text();
          return;
        }

        if (
          $(item)[0].tagName == "INPUT" &&
          $(item).hasClass("agreement") &&
          !$("input[type=checkbox]").is(":checked")
        ) {
          errorLabel = true;
          validationSuffix = "_agreement";
        }
      }
    });
    if (errorLabel) {
      let text = global.Translator.trans(
        "booking.validation" + validationSuffix,
        { text: errorLabel },
        "js"
      );
      alert(text);
      return false;
    }
    return true;
  };

  if ($(".prompt-helper").length && $(".prompt-proposal").length) {
    const toggleAiGenerateBtnState = ($btn, state) => {
      switch (state) {
        case "loading":
          $btn.addClass("loading").find(".loader").removeClass("hidden");
          $btn.find(".label").text($btn.data("loading"));
          $btn.show();
          break;
        case "reset":
          $btn.removeClass("loading").find(".loader").addClass("hidden");
          $btn.find(".label").text($btn.data("generate"));
          $btn.show();
          break;
        case "regenerate":
          $btn.removeClass("loading").find(".loader").addClass("hidden");
          $btn.removeClass("btn--secondary").addClass("btn--tertiary");
          $btn.find(".label").text($btn.data("regenerate"));
          $btn.show();
          break;
        case "hide":
          $btn.find(".label").text($btn.data("generate"));
          $btn.removeClass("loading").find(".loader").addClass("hidden");

          $btn.hide();
          break;
      }
    };

    // AI text generation
    $(".ai-generate:not(.loading)").on("click", function () {
      const $aiGenerateBtn = $(this);
      const $promptHelper = $aiGenerateBtn.parent(".prompt-helper");
      const $promptProposal = $aiGenerateBtn
        .closest(".languageBox")
        .find(".prompt-proposal");

      const amenities = $promptHelper.data("amenities");
      const address = $promptHelper.data("address");
      const language = $promptHelper.data("language");
      const generatorType = $promptHelper.data("generator-type");
      const enhancements = $promptHelper.data("enhancements") || "";
      const currentValue = $promptHelper.data("current-value") || "";

      let keywords = $promptHelper.data("type");
      let textType = "heading";
      let context = "temporary renting";

      toggleAiGenerateBtnState($aiGenerateBtn, "loading");

      if (generatorType === "description") {
        context = $promptHelper.data("audience") || context;
        keywords = $("#text_taglines_" + lang).val() || keywords;
        textType = "description";
      }

      TextGenerator(
        language,
        textType,
        currentValue,
        amenities,
        address,
        context,
        keywords,
        $("#rental_type").length > 0 &&
          $("#rental_type").val() !== "undefined" &&
          $("#rental_type").val() !== "OTHER"
          ? $("#rental_type").val().toLowerCase()
          : "accommodation",
        enhancements
      )
        .then((description) => {
          description = description.replace(/^"|"$/g, ""); // remove quotes from start and end

          toggleAiGenerateBtnState($aiGenerateBtn, "hide");

          $promptProposal
            .find(".result")
            .html(description.replace(/\n/g, "<br>"));
          $promptProposal.show();

          if (enhancements) {
            $promptProposal.find(".dropdown-toggle.open").trigger("click");
          } else {
            $promptProposal.find(".dropdown").show();
          }
        })
        .catch((error) => {
          alert(error);
          toggleAiGenerateBtnState($aiGenerateBtn, "regenerate");
        });
    });

    // AI text proposal actions
    $(".prompt-proposal").on("click", "[data-action]", function () {
      const $promptProposal = $(this).closest(".prompt-proposal");
      const $aiGenerateBtn = $(this)
        .closest(".languageBox")
        .find(".ai-generate");
      const $promptHelper = $aiGenerateBtn.parent(".prompt-helper");
      const $textarea = $(
        $aiGenerateBtn.parent(".prompt-helper").data("target")
      ).find("textarea");

      const result = $promptProposal.find(".result").html();

      const resetDropdown = () => {
        $promptHelper.removeData("enhancements"); // reset enhancements
        $promptProposal.find("[data-enhancement].active").trigger("click");
        $promptProposal.find(".dropdown-toggle").removeClass("open");
      };

      switch ($(this).data("action")) {
        case "accept":
          $textarea
            .val(result.replace(/<br>/g, "\n"))
            .trigger("input")
            .trigger("keyup")
            .focus();
          $textarea
            .parent()
            .find("label")
            .addClass("mdc-floating-label--float-above");
          $promptProposal.hide();
          resetDropdown();
          toggleAiGenerateBtnState($aiGenerateBtn, "regenerate");
          break;
        case "discard":
          $promptProposal.hide();
          resetDropdown();
          toggleAiGenerateBtnState($aiGenerateBtn, "reset");
          break;
        case "enhance":
          $promptProposal.hide();
          toggleAiGenerateBtnState($aiGenerateBtn, "loading");
          const enhancements = $promptProposal
            .find("[data-enhancement].active")
            .map((index, element) => $(element).data("enhancement"))
            .get();
          $promptHelper.data("enhancements", enhancements.join(", "));
          $promptHelper.data("current-value", result);
          $aiGenerateBtn.trigger("click");
          break;
        default:
          break;
      }
    });
  }
  if ($(".keyword-hint-field").length) {
    const $keywordHint = $(".keyword-hint-field").next(".keyword-hint");
    $(".keyword-hint-field").on("keyup", "input", function () {
      const $this = $(this);
      const $input = $this.find("input[type=text]");
      const portals = $this.parents().eq(0).data("portals");
      const keywords = $this.parents().eq(0).data("keywords");

      const currentValue = $this.val();
      let foundKeyword = null;
      if (portals.length > 1 || !portals.includes("MZ")) {
        $.each(keywords, (index, keyword) => {
          if (
            foundKeyword == null &&
            currentValue.toLowerCase().includes(keyword)
          ) {
            foundKeyword = keyword;
            $keywordHint.find(".found-keyword").remove();
            $keywordHint.prepend(
              '<span class="found-keyword strong small">"' +
                foundKeyword +
                '"</span>'
            );
            $keywordHint.removeClass("hidden");
            return true;
          } else if (foundKeyword == null) {
            $keywordHint.find(".found-keyword").remove();
            $keywordHint.addClass("hidden");
          }
        });
      }
    });
  }
}
